import { render, staticRenderFns } from "./businessDetailGoods.vue?vue&type=template&id=712e4a82&scoped=true"
import script from "./businessDetailGoods.vue?vue&type=script&lang=js"
export * from "./businessDetailGoods.vue?vue&type=script&lang=js"
import style0 from "./businessDetailGoods.vue?vue&type=style&index=0&id=712e4a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712e4a82",
  null
  
)

export default component.exports